import React, { useState, useContext, useRef, useEffect } from 'react';
import { useNavigate, useLocation, matchPath } from 'react-router-dom';
import { useTheme } from '@material-ui/core/styles';
import { debounce } from 'lodash';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import PropTypes from 'prop-types';
import {
  AppBar,
  Box,
  Hidden,
  IconButton,
  Toolbar,
  Button,
} from '@material-ui/core';
import LogoDashboard from './LogoDashboard';
import GlobalMenu from "./GlobalMenu"
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';

import { logout } from "../utils/auth"
import getInitials from '../utils/getInitials';


import UserContext from "../contexts/UserContext"
import LanguageContext from "../contexts/LanguageContext"


const DashboardNavbar = ({ ...props }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const {
    actLanguage,
    languageValues,
  } = useContext(LanguageContext)

  const {
    updateUserContext,
    currentUser,
  } = useContext(UserContext)


  const globalMenuRef = useRef(null)
  const [globalMenu, setGlobalMenu] = useState(false)

  const handleOutsideClick = (e) => {
    if (globalMenuRef.current && !globalMenuRef.current.contains(e.target)) {
      setGlobalMenu(false)
    }
    if (observedElementRef.current && !observedElementRef.current.contains(e.target)) {
      if (e?.target?.classList?.contains("customForClickMenuMobile")) {
        e?.target?.classList?.forEach((classe) => {
          if (classe?.includes("goToPage-")) {
            let pageID = classe?.replace("goToPage-", "")
            if (props?.menuforadmin === "true") {
              //forAdminMenu
              let find = itemsMenuAdmin?.find((el) => el.page === pageID)
              if (find) {
                goToThisPage('/admin/'+find?.page)
              }
            } else {
              //for classicMenu
              let find = itemsMenu?.find((el) => el.page === pageID)
              if (find) {
                goToThisPage('/'+find?.page)
              }
            }
          }
        })
      }
      setMenuMobileDropdown(false)
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  const itemsMenuAdmin = [
    {
      page: 'groupe',
      title: "Groupes",
    },
    {
      page: 'formation',
      title: "Modules",
    },
    {
      page: 'ecoles',
      title: "Écoles",
    },
    {
      page: 'adminclient',
      title: "Admin Clients",
    },
  ];

  const itemsMenu = [
    {
      page: 'dashboard',
      title: languageValues?.studentMenu?.dashboard[actLanguage],
    },
    {
      page: 'myCertification',
      title: languageValues?.studentMenu?.myCertif[actLanguage],
    },
  ];

  const [menuMobileDropdown, setMenuMobileDropdown] = useState(false)
  const theme = useTheme();
  const mediaQueryUpMd = useMediaQuery(theme.breakpoints.up('md'));
  const mediaQueryUpSm = useMediaQuery(theme.breakpoints.up('sm'));
  const observedElementRef = useRef(null);
  const [leftOffsetForMobileMenu, setLeftOffsetForMobileMenu] = useState(99999)
  const [widthForMobileMenu, setWidthForMobileMenu] = useState(0)
  useEffect(() => {
    if (observedElementRef.current) {
      const observer = new ResizeObserver(debounce((entries) => {
        for (let entry of entries) {
          setLeftOffsetForMobileMenu(observedElementRef?.current?.getBoundingClientRect()?.left - 11)
          setWidthForMobileMenu(observedElementRef?.current?.getBoundingClientRect()?.width + 11)
          return
        }
      }));
      observer.observe(observedElementRef?.current);
      return () => {
          observer.disconnect();
      };
    }
  }, [observedElementRef?.current, mediaQueryUpMd, mediaQueryUpSm]);

  useEffect(() => {
    if (mediaQueryUpMd === true && menuMobileDropdown === true) {
      setMenuMobileDropdown(false)
    }
  }, [mediaQueryUpMd, menuMobileDropdown])

  const getActPageForMenuMobileAdmin = () => {
    let split = window?.location?.pathname?.split('/')
    split = split.filter((el) => el !== '')
    let find = itemsMenuAdmin?.find((el) => el.page === split[1])
    if (find) {
      return find?.title
    }
    return ""
  }

  const getActPageForMenuMobile = () => {
    let split = window?.location?.pathname?.split('/')
    split = split.filter((el) => el !== '')
    let find = itemsMenu?.find((el) => el.page === split[0])
    if (find) {
      return find?.title
    }
    return ""
  }

  const goToThisPage = (page) => {
    navigate(page)
  }


  return (
    <AppBar
      elevation={0}
      sx={{background:"#FFFFFF", borderBottom:"1px solid black"}}
      {...props}
    >
      <Toolbar
        sx={{
          height: ["55px !important", "65px !important"],
          minHeight: ["55px !important", "65px !important"],
          background:"#FFFFFF",
        }}>
        <Box sx={{
          display:"flex",
          alignItems:"center",
          height:"100%",
          maxWidth:"calc(100vw - 100px)",
        }}>
          <Box sx={{
            marginLeft:"5px",
            marginRight:["0px", "25px"],
            paddingRight:["15px", "0px"],
            display:"flex",
            alignItems:"center",
            cursor:"pointer",
            borderRight:["2px solid #E6E6E7", "0"],
          }} onClick={() => navigate("/")}>
            <LogoDashboard />
          </Box>

            {props?.menuforadmin === "true" ? (
              <>
                <Hidden mdDown>
                  <Box sx={{display:"flex", marginLeft:"25px", marginRight:"25px", justifyContent:"space-between", gap:"30px"}}>
                    {itemsMenuAdmin.map((item, index) => {
                      let active = false
                      let split = window?.location?.pathname?.split('/')
                      split = split.filter((el) => el !== '')
                      if (split[1] === item?.page) {
                        active = true
                      }
                      return (
                        <Button
                          key={index}
                          disableRipple
                          onClick={() => {
                            goToThisPage('/admin/'+item?.page)
                          }}
                          sx={{
                            fontSize:"16px",
                            color:"text.secondary",
                            textDecoration:active && "underline",
                            textUnderlineOffset: "6px",
                            minWidth:0,
                            "&:hover" : {
                              background:"transparent",
                              color:"rgba(0,0,0,0.75)",
                              textDecoration:active && "underline",
                            }
                          }}
                          size="small"
                        >
                          <span>
                            {item?.title}
                          </span>
                        </Button>
                      )
                    })}

                  </Box>
                </Hidden>
                <Hidden mdUp>
                  <Box ref={observedElementRef} sx={{display:"flex", marginLeft:"10px", marginRight:"0px", justifyContent:"space-between", gap:"30px", overflow:"hidden"}}>
                    <Box
                      onClick={() => { setMenuMobileDropdown(!menuMobileDropdown) }}
                      sx={{
                        display:"flex",
                        height:"100%",
                        alignItems:"center",
                        padding:"15px",
                        overflow:"hidden",
                        cursor:"pointer",
                        gap:"8px",
                        color:"text.secondary",
                      }}
                    >
                      <span style={{
                        textTransform:"capitalize",
                        whiteSpace:"nowrap",
                        overflow:"hidden",
                        textOverflow:"ellipsis",
                      }}>{getActPageForMenuMobileAdmin()}</span>
                      <KeyboardArrowDownIcon sx={{
                        transform:menuMobileDropdown === true && "rotate(180deg)",
                      }}/>
                    </Box>
                  </Box>
                  {menuMobileDropdown === true &&
                    <Box sx={{
                      width:widthForMobileMenu+"px",
                      position: "absolute",
                      top:["56px", "66px"],
                      left:leftOffsetForMobileMenu+"px",
                      borderLeft:"1px solid black",
                      borderRight:"1px solid black",
                      borderBottom:"1px solid black",
                      boxShadow: "0px 1px 20px rgba(0, 0, 0, 0.1)",
                      cursor:"pointer",
                      display:"flex",
                      flexDirection:"column",
                      overflow:"hidden",
                      background:"white",
                    }}>
                      {itemsMenuAdmin.map((item, index) => {
                        let active = false
                        let split = window?.location?.pathname?.split('/')
                        split = split.filter((el) => el !== '')
                        if (split[1] === item?.page) {
                          active = true
                        }
                        return (
                          <Button
                            key={index}
                            className={"customForClickMenuMobile goToPage-"+item?.page}
                            disableRipple
                            sx={{
                              height:'50px !important',
                              minHeight:'50px !important',
                              fontSize:"15px !important",
                              color:"text.secondary",
                              textDecoration:active && "underline",
                              textUnderlineOffset: "6px",
                              minWidth:0,
                              "&:hover" : {
                                background:"transparent",
                                color:"rgba(0,0,0,0.75)",
                                textDecoration:active && "underline",
                              }
                            }}
                            size="small"
                          >
                            <span className={"customForClickMenuMobile goToPage-"+item?.page}>
                              {item?.title}
                            </span>
                          </Button>
                        )
                      })}
                    </Box>
                  }
                </Hidden>
              </>
            ) : (
              <>
                <Hidden mdDown>
                  <Box sx={{display:"flex", marginLeft:"25px", marginRight:"25px", justifyContent:"space-between", gap:"30px"}}>
                    {itemsMenu.map((item, index) => {
                      let active = false
                      let split = window?.location?.pathname?.split('/')
                      split = split.filter((el) => el !== '')
                      if (split[0] === item?.page) {
                        active = true
                      }
                      return (
                        <Button
                          key={index}
                          disableRipple
                          onClick={() => {
                            goToThisPage('/'+item?.page)
                          }}
                          sx={{
                            fontSize:"16px",
                            color:"text.secondary",
                            textDecoration:active && "underline",
                            textUnderlineOffset: "6px",
                            minWidth:0,
                            "&:hover" : {
                              background:"transparent",
                              color:"rgba(0,0,0,0.75)",
                              textDecoration:active && "underline",
                            }
                          }}
                          size="small"
                        >
                          <span>
                            {item?.title}
                          </span>
                        </Button>
                      )
                    })}

                  </Box>
                </Hidden>
                <Hidden mdUp>
                  <Box ref={observedElementRef} sx={{display:"flex", marginLeft:"10px", marginRight:"0px", justifyContent:"space-between", gap:"30px", overflow:"hidden"}}>
                    <Box
                      onClick={() => { setMenuMobileDropdown(!menuMobileDropdown) }}
                      sx={{
                        display:"flex",
                        height:"100%",
                        alignItems:"center",
                        padding:"15px",
                        overflow:"hidden",
                        cursor:"pointer",
                        gap:"8px",
                        color:"text.secondary",
                      }}
                    >
                      <span style={{
                        textTransform:"capitalize",
                        whiteSpace:"nowrap",
                        overflow:"hidden",
                        textOverflow:"ellipsis",
                      }}>{getActPageForMenuMobile()}</span>
                      <KeyboardArrowDownIcon sx={{
                        transform:menuMobileDropdown === true && "rotate(180deg)",
                      }}/>
                    </Box>
                  </Box>
                  {menuMobileDropdown === true &&
                    <Box sx={{
                      width:widthForMobileMenu+"px",
                      position: "absolute",
                      top:["56px", "66px"],
                      left:leftOffsetForMobileMenu+"px",
                      borderLeft:"1px solid black",
                      borderRight:"1px solid black",
                      borderBottom:"1px solid black",
                      boxShadow: "0px 1px 20px rgba(0, 0, 0, 0.1)",
                      cursor:"pointer",
                      display:"flex",
                      flexDirection:"column",
                      overflow:"hidden",
                      background:"white",
                    }}>
                      {itemsMenu.map((item, index) => {
                        let active = false
                        let split = window?.location?.pathname?.split('/')
                        split = split.filter((el) => el !== '')
                        if (split[0] === item?.page) {
                          active = true
                        }
                        return (
                          <Button
                            key={index}
                            className={"customForClickMenuMobile goToPage-"+item?.page}
                            disableRipple
                            sx={{
                              height:'50px !important',
                              minHeight:'50px !important',
                              fontSize:"15px !important",
                              color:"text.secondary",
                              textDecoration:active && "underline",
                              textUnderlineOffset: "6px",
                              minWidth:0,
                              "&:hover" : {
                                background:"transparent",
                                color:"rgba(0,0,0,0.75)",
                                textDecoration:active && "underline",
                              }
                            }}
                            size="small"
                          >
                            <span className={"customForClickMenuMobile goToPage-"+item?.page}>
                              {item?.title}
                            </span>
                          </Button>
                        )
                      })}
                    </Box>
                  }
                </Hidden>
              </>
            )}

        </Box>
        <Box sx={{ flexGrow: 1 }}>
        </Box>


        <GlobalMenu
          globalMenu={globalMenu}
          setGlobalMenu={setGlobalMenu}
          globalMenuRef={globalMenuRef}
          updateUserContext={updateUserContext}
          currentUser={currentUser}
        />


      </Toolbar>
    </AppBar>
  );
};


export default DashboardNavbar;
